import { useNavigate } from 'react-router-dom';
import StyledButton from '../../../components/Button/Button';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import { Container, Box, Typography, FormControl } from '@mui/material';
import TopNav from '../../../components/TopNav/TopNav';
import { useContext, useState, useEffect } from 'react';
import './SelectPlan.css';
import { ProfileContext } from '../../../context/ProfileContext';
import { AuthContext } from '../../../context/AuthContext';
import { getStage } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';

const SelectPlan: React.FC = () => {
  const profileContext = useContext(ProfileContext);

  if (!profileContext) {
    throw new Error('ProfileContext must be used within a ProfileProvider');
  }
  const { autoRenewal, handleAutoRenewal } = profileContext;

  const authContext = useContext(AuthContext);

  if (!authContext) {
    throw new Error('Auth Context must be used within a AuthProvider');
  }

  const [errorMsg, setErrorMsg] = useState<string>('');

  const onChecked = () => {
    handleAutoRenewal();
  };

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        console.log('inside use effect');
        const response = await getStage();
        const data = await response.data;
        if (data) {
          console.log('stage is', data.data.stage);
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/participant/createProfile');
          }
          if (stage === '2') {
            navigate('/participant/inviteBabySitter');
          }
          if (stage === '4') {
            navigate('/participant/dashboard');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  const handleContinue = async () => {
    navigate(`/participant/payment?autoRenewal=${autoRenewal}`);
  };

  return (
    <StyledBgContainer>
      <TopNav />
      <Container maxWidth="sm">
        <Box component="form" noValidate autoComplete="off">
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              px: { sm: 4 },
            }}
          >
            <Typography
              variant="h6"
              sx={{ color: 'white', fontFamily: 'Opensans', fontWeight: '700' }}
            >
              Required Fees
            </Typography>

            <Typography
              variant="body2"
              sx={{ color: 'grey', mt: 1, mb: 4, textAlign: 'center' }}
            >
              Associated fees are as follows. These do not reflect an additional
              3% surcharge for credit card processing.
            </Typography>

            <FormControl
              fullWidth
              variant="outlined"
              sx={{
                gap: 2,
                mb: 1,
                alignItems: 'center',
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row', md: 'row' }, // Switch to column on xs and sm, row on md and larger
                justifyContent: 'center',
              }}
            >
              {/* First Box */}
              <Box
                className="upload-container"
                sx={{
                  py: 3,
                  px: { xs: 1, sm: 3 },
                  width: { xs: '80vw', sm: '80vw', md: '40vw' }, // Wider on small screens for better spacing
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: 'white',
                    fontFamily: 'Opensans',
                    fontWeight: '700',
                  }}
                >
                  $102.17
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 3,
                    color: 'white',
                    fontFamily: 'Opensans',
                    fontSize: '15px',
                    fontWeight: '700',
                    mb: 1,
                  }}
                >
                  Activation Fee
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    px: { xs: 4, sm: 4, md: 0 },
                    fontSize: '10px',
                    color: 'grey',
                    mb: 4,
                  }}
                >
                  This is a one-time charge to cover costs associated with
                  initiating your account.
                </Typography>
                <Box sx={{ height: '30px' }} />
              </Box>

              {/* Second Box */}
              <Box
                className="upload-container"
                sx={{
                  py: 3,
                  px: { xs: 1, sm: 3 },
                  width: { xs: '80vw', sm: '80vw', md: '40vw' }, // Wider on small screens for better spacing
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography
                  variant="h4"
                  sx={{
                    color: 'white',
                    fontFamily: 'Opensans',
                    fontWeight: '700',
                  }}
                >
                  $194.78
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    mt: 3,
                    color: 'white',
                    fontFamily: 'Opensans',
                    fontWeight: '700',
                    fontSize: '15px',
                    mb: 1,
                  }}
                >
                  Monthly Plan
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ fontSize: '10px', color: 'grey', mb: 3 }}
                >
                  Due monthly to remain a Participant and utilize our mobile
                  application.
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 0.5,
                    height: '30px',
                  }}
                >
                  <input
                    type="checkbox"
                    id="renew-checkbox"
                    onChange={onChecked}
                    checked={autoRenewal}
                    className="checkboxplan"
                  />
                  <label htmlFor="renew-checkbox" className="auto-renew-text">
                    Auto Renew
                  </label>
                </Box>
              </Box>
            </FormControl>
          </Box>

          <Box sx={{ mb: 6, display: 'flex', justifyContent: 'center' }}>
            <StyledButton onClick={handleContinue}>Acknowledge</StyledButton>
          </Box>
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default SelectPlan;
